<template>
    <div>
        <section class="totalizers-container">
            <div class="totalizers-list">
                <totalizer-block
                    :text="translate('messages.successfully_processed_files')"
                    :number="totalizers.batchesProcessed"
                    :noIconTotalizer="true"
                />
                <totalizer-block
                    :text="translate('messages.files_in_progress')"
                    :number="totalizers.batchesInProcessing"
                    iconClass="lyra-icon lyra-volume-vendido"
                    :noIconTotalizer="true"
                />
                <totalizer-block
                    :text="translate('messages.files_with_errors')"
                    :number="totalizers.batchesError"
                    :noIconTotalizer="true"
                />
            </div>

        </section>

    </div>
</template>

<script>
import TotalizerBlock from '@/modules/warehouse/views/components/TotalizerBlock.vue';
import FilaProcessamentoRastreabilidadeService from '@/services/FilaProcessamentoRastreabilidadeService';
import formatters from '@/utils/formatters';

export default {
    name: 'TotalizersBatchRecordDefault',
    components: { TotalizerBlock },
    data() {
        return {
            totalizers: {
                batchesProcessed: '-',
                batchesInProcessing: '-',
                batchesError: '-'
            }
        };
    },
    computed: {
    },
    mounted() {
        this.getTotalizers();
    },
    watch: {
        filters: {
            handler(newVal) {
                this.getTotalizers();
            },
            deep: true
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        async getTotalizers() {
            await FilaProcessamentoRastreabilidadeService.fetchProcessingQueueTotalizers().then(({ data }) => {
                this.totalizers.batchesProcessed = data.totalProcessados != null ? formatters.formatNumber(data.totalProcessados, 0, this.$i18n.locale) : '-';
                this.totalizers.batchesInProcessing = data.totalEmProcessamento != null ? formatters.formatNumber(data.totalEmProcessamento, 0, this.$i18n.locale) : '-';
                this.totalizers.batchesError = data.totalComErro != null ? formatters.formatNumber(data.totalComErro, 0, this.$i18n.locale) : '-';
            });
        }
    }
};
</script>

<style scoped lang="scss">
.totalizers-container {
    h3 {
        margin-bottom: 10px;
        margin-top: 10px;
        color: var(--black);
        font-weight: 500;
    }

    .totalizers-list {
        width: 100%;
        display: grid;
        column-gap: 16px;
        grid-template-columns: 1fr 1fr 1fr;
    }
}
</style>
